var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_40646",
    "data-name": "Gruppe 40646",
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_40452",
    "data-name": "Gruppe 40452",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_529",
    "data-name": "Ellipse 529",
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#e5f5f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_40647",
    "data-name": "Gruppe 40647",
    transform: "translate(23.342 15.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_48016",
    "data-name": "Pfad 48016",
    d: "M15.717,0H3.934A3.771,3.771,0,0,0,.168,3.767V31.646a3.77,3.77,0,0,0,3.766,3.766H15.717a3.771,3.771,0,0,0,3.767-3.766V3.767A3.771,3.771,0,0,0,15.717,0Zm2.157,31.646A2.159,2.159,0,0,1,15.717,33.8H3.934a2.159,2.159,0,0,1-2.157-2.157V3.767A2.159,2.159,0,0,1,3.934,1.61H15.717a2.159,2.159,0,0,1,2.157,2.157Zm0,0",
    transform: "translate(-0.168)",
    fill: "#1d9d87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_48017",
    "data-name": "Pfad 48017",
    d: "M91.134,42.668H86.3a.8.8,0,1,0,0,1.61h4.829a.8.8,0,0,0,0-1.61Zm0,0",
    transform: "translate(-79.061 -39.449)",
    fill: "#1d9d87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_48018",
    "data-name": "Pfad 48018",
    d: "M110.051,385.61a1.61,1.61,0,1,1-1.61-1.61A1.61,1.61,0,0,1,110.051,385.61Zm0,0",
    transform: "translate(-98.784 -355.026)",
    fill: "#1d9d87"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApp);
export default __webpack_public_path__ + "static/media/Icon-App.d8cd634b8a39bf047e7c9e4491d422d7.svg";
export { ForwardRef as ReactComponent };